module.exports = __webpack_public_path__ + "static/media/ic_green_msg.9336c23a.svg";